import {
  AppPageHeader,
  ColumnsType,
  DeleteIcon,
  EditIcon,
  InfiniteTable,
} from '@/components/_common';
import { useDebounce, useDisclosure } from '@/hooks';
import { usePersistSearchParams } from '@/utils/queryParams';
import convertParams from '@/utils/queryParams/convertParams';
import { Divider, Modal, Space } from 'antd';
import { useState } from 'react';
import { useIntl } from 'react-intl';
import { WorkOrderStatusQueryFilter } from '@/core/domain/workorder/WorkOrderStatus/WorkOrderStatus.types';
import StatusWorkOrderModal from '../StatusWorkOrderModal';
import { GPStatus } from '@/core/domain/visual-management/status/status.types';
import {
  useGPStatusDelete,
  useGPStatusList,
} from '@/core/domain/visual-management/status/status.hooks';
import WorkOrderStatusTag from '@/components/_common/WorkOrderStatusTag';

export default function StatusWorkOrderList() {
  const intl = useIntl();

  const [queryParams, setQueryParams] = useState<WorkOrderStatusQueryFilter>({
    order: 'ASC',
    ...convertParams<WorkOrderStatusQueryFilter>({
      search: 'string',
    }),
  });
  const [statusSelected, setStatusSelected] = useState<GPStatus>();
  const [modalEditOpened, modalEditActions] = useDisclosure();

  const queryDebounce = useDebounce(queryParams, 500);
  usePersistSearchParams(queryDebounce);

  const { data, isFetching } = useGPStatusList();

  const deleteStatus = useGPStatusDelete();

  const handleRemoveClick = (id: string) => {
    Modal.confirm({
      title: 'Atenção!',
      content: 'Deseja realmente excluir esse status?',
      onOk: async () => {
        await deleteStatus.mutateAsync(id);
      },

      okType: 'danger',
    });
  };

  const columns: ColumnsType<GPStatus> = [
    {
      dataIndex: 'name',
      title: 'Descrição',
      render: (_, record) => (
        <WorkOrderStatusTag color={record.color} label={record.name} />
      ),
    },
    {
      dataIndex: 'actions',
      title: intl.formatMessage({ id: 'customers.list.header.actions' }),
      render: (_, row) => (
        <Space>
          <EditIcon
            iconProps={{
              onClick: () => {
                setStatusSelected(row);
                modalEditActions.open();
              },
            }}
          />

          <Divider type="vertical" />

          <DeleteIcon onClick={() => handleRemoveClick(row.id)} />
        </Space>
      ),
      width: 100,
      align: 'right',
      fixed: 'right',
    },
  ];

  return (
    <>
      <AppPageHeader
        onSearch={(value) =>
          setQueryParams((prev) => ({ ...prev, search: value }))
        }
      />

      <InfiniteTable<GPStatus>
        columns={columns}
        dataSource={data}
        loading={isFetching}
        rowKey={(row) => row.id}
      />

      <StatusWorkOrderModal
        statusSelected={statusSelected}
        open={modalEditOpened}
        onCancel={() => {
          modalEditActions.close();
          setStatusSelected(undefined);
        }}
      />
    </>
  );
}
